(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('lodash'), require('prop-types')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'lodash', 'prop-types'], factory) :
  (global = global || self, factory(global.IOForm = {}, global.React, global._, global.PropTypes));
}(this, function (exports, React, _$1, PropTypes) { 'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  var _$1__default = 'default' in _$1 ? _$1['default'] : _$1;
  var PropTypes__default = 'default' in PropTypes ? PropTypes['default'] : PropTypes;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var classCallCheck = _classCallCheck;

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var createClass = _createClass;

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

  function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return _typeof2(obj);
      };
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
      };
    }

    return _typeof(obj);
  }

  module.exports = _typeof;
  });

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  var assertThisInitialized = _assertThisInitialized;

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
      return call;
    }

    return assertThisInitialized(self);
  }

  var possibleConstructorReturn = _possibleConstructorReturn;

  var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  module.exports = _getPrototypeOf;
  });

  var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf;
  });

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) setPrototypeOf(subClass, superClass);
  }

  var inherits = _inherits;

  var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
  });

  var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var runtime = (function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);

      // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.
      generator._invoke = makeInvokeMethod(innerFn, self, context);

      return generator;
    }
    exports.wrap = wrap;

    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
      try {
        return { type: "normal", arg: fn.call(obj, arg) };
      } catch (err) {
        return { type: "throw", arg: err };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";

    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};

    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}

    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype &&
        NativeIteratorPrototype !== Op &&
        hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype =
      Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] =
      GeneratorFunction.displayName = "GeneratorFunction";

    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method) {
        prototype[method] = function(arg) {
          return this._invoke(method, arg);
        };
      });
    }

    exports.isGeneratorFunction = function(genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor
        ? ctor === GeneratorFunction ||
          // For the native GeneratorFunction constructor, the best we can
          // do is to check its .name property.
          (ctor.displayName || ctor.name) === "GeneratorFunction"
        : false;
    };

    exports.mark = function(genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };

    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
      return { __await: arg };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value &&
              typeof value === "object" &&
              hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function(value) {
              invoke("next", value, resolve, reject);
            }, function(err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function(unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function(error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function(resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise =
          // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(
            callInvokeWithMethodAndArg,
            // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg
          ) : callInvokeWithMethodAndArg();
      }

      // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).
      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };
    exports.AsyncIterator = AsyncIterator;

    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(
        wrap(innerFn, outerFn, self, tryLocsList)
      );

      return exports.isGeneratorFunction(outerFn)
        ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
          });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;

      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }

          // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;

          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);

          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;

          var record = tryCatch(innerFn, self, context);
          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done
              ? GenStateCompleted
              : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };

          } else if (record.type === "throw") {
            state = GenStateCompleted;
            // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }

    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError(
            "The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (! info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value;

        // Resume execution at the desired location (see delegateYield).
        context.next = delegate.nextLoc;

        // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }

      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      }

      // The delegate iterator is finished, so forget it and continue with
      // the outer generator.
      context.delegate = null;
      return ContinueSentinel;
    }

    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);

    Gp[toStringTagSymbol] = "Generator";

    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function() {
      return this;
    };

    Gp.toString = function() {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = { tryLoc: locs[0] };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{ tryLoc: "root" }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function(object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();

      // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.
      return function next() {
        while (keys.length) {
          var key = keys.pop();
          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        }

        // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.
        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1, next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;

            return next;
          };

          return next.next = next;
        }
      }

      // Return an iterator with no values.
      return { next: doneResult };
    }
    exports.values = values;

    function doneResult() {
      return { value: undefined$1, done: true };
    }

    Context.prototype = {
      constructor: Context,

      reset: function(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.
        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;

        this.method = "next";
        this.arg = undefined$1;

        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" &&
                hasOwn.call(this, name) &&
                !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },

      stop: function() {
        this.done = true;

        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },

      dispatchException: function(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !! caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }

            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }

            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }

            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },

      abrupt: function(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev &&
              hasOwn.call(entry, "finallyLoc") &&
              this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry &&
            (type === "break" ||
             type === "continue") &&
            finallyEntry.tryLoc <= arg &&
            arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },

      complete: function(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" ||
            record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },

      finish: function(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },

      "catch": function(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }

        // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.
        throw new Error("illegal catch attempt");
      },

      delegateYield: function(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    };

    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;

  }(
    // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
     module.exports 
  ));

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
  });

  var regenerator = runtime_1;

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  var asyncToGenerator = _asyncToGenerator;

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var defineProperty = _defineProperty;

  var IOInputMessageContext = React__default.createContext({
    set: function set() {},
    pool: {}
  });
  /** Collects the information for any child node of type IOInput */

  var MessageContext =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(MessageContext, _React$PureComponent);

    function MessageContext() {
      var _getPrototypeOf2;

      var _this;

      classCallCheck(this, MessageContext);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(MessageContext)).call.apply(_getPrototypeOf2, [this].concat(args)));

      defineProperty(assertThisInitialized(_this), "registry", {});

      defineProperty(assertThisInitialized(_this), "dispatch", function () {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var field = arguments.length > 1 ? arguments[1] : undefined;
        var reg = _this.registry[field];

        if (reg) {
          Object.values(reg).forEach(function (setter) {
            return setter(message);
          });
        }
      });

      defineProperty(assertThisInitialized(_this), "subscribe", function (field, uuid, setter) {
        if (!_this.registry[field]) {
          _this.registry[field] = {};
        }

        _this.registry[field][uuid] = setter;
      });

      defineProperty(assertThisInitialized(_this), "unsubscribe", function (field, uuid) {
        delete _this.registry[field][uuid];
      });

      return _this;
    }

    createClass(MessageContext, [{
      key: "render",
      value: function render() {
        return React__default.createElement(IOInputMessageContext.Provider, {
          value: {
            subscribe: this.subscribe,
            unsubscribe: this.unsubscribe,
            dispatch: this.dispatch
          }
        }, this.props.children);
      }
    }]);

    return MessageContext;
  }(React__default.PureComponent);
  /** Message Holder for the Messages */

  var IOInputMessage =
  /*#__PURE__*/
  function (_React$PureComponent2) {
    inherits(IOInputMessage, _React$PureComponent2);

    function IOInputMessage(props) {
      var _this2;

      classCallCheck(this, IOInputMessage);

      _this2 = possibleConstructorReturn(this, getPrototypeOf(IOInputMessage).call(this, props));

      defineProperty(assertThisInitialized(_this2), "_identifier", null);

      defineProperty(assertThisInitialized(_this2), "state", {
        message: ''
      });

      defineProperty(assertThisInitialized(_this2), "setter", function (message) {
        _this2.setState({
          message: message
        });
      });

      _this2._identifier = "".concat(props["for"], "_").concat(new Date().getTime(), "_").concat(Math.round(Math.random() * 10000));
      return _this2;
    }

    createClass(IOInputMessage, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.context.subscribe(this.props["for"], this._identifier, this.setter);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.context.unsubscribe(this.props["for"], this._identifier);
      }
    }, {
      key: "render",
      value: function render() {
        var message = this.state.message;
        var text = this.props.text;
        return React__default.createElement(React__default.Fragment, null, text ? message || '' : React__default.createElement("label", {
          className: "iof-message"
        }, message || ''));
      }
    }]);

    return IOInputMessage;
  }(React__default.PureComponent); // export const IOInputMessage = (props) => (
  //     <IOInputMessageContext.Consumer>
  //         { context =>
  //             <Fragment>
  //                 {props.text ? (context.pool[props.for] || '') : <label className="iof-message">{context.pool[props.for] || ''}</label>}
  //             </Fragment>
  //         }
  //     </IOInputMessageContext.Consumer>
  // )

  defineProperty(IOInputMessage, "contextType", IOInputMessageContext);

  IOInputMessage.propTypes = {
    /** Name of the input which this label will be linked to */
    'for': PropTypes__default.string.isRequired,

    /** Name of the prop that indicates to render the text as a simple text node. */
    text: PropTypes__default.bool
  };
  IOInputMessage.defaultProps = {
    text: false
  };

  var IOInputLinkageContext = React__default.createContext();
  var LinkageContext =
  /*#__PURE__*/
  function (_React$Component) {
    inherits(LinkageContext, _React$Component);

    function LinkageContext() {
      var _getPrototypeOf2;

      var _this;

      classCallCheck(this, LinkageContext);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(LinkageContext)).call.apply(_getPrototypeOf2, [this].concat(args)));

      defineProperty(assertThisInitialized(_this), "fields", {});

      defineProperty(assertThisInitialized(_this), "register", function (name, controller) {
        _this.fields[name] = controller;
        controller.observe(_this.valueChanged);
      });

      defineProperty(assertThisInitialized(_this), "unregister", function (name) {
        delete _this.fields[name];
      });

      defineProperty(assertThisInitialized(_this), "valueChanged", function (_ref) {
        var value = _ref.value,
            ioProps = _ref.ioProps;

        if (ioProps.link) {
          _this.notify(ioProps.link, value);
        }
      });

      defineProperty(assertThisInitialized(_this), "notify", function (link, value) {
        if (_$1__default.isArray(link)) {
          link.forEach(function (l) {
            return _this.notify(l, value);
          });
          return;
        }

        var fieldController = _this.fields[link];

        if (fieldController) {
          fieldController.inject(value, link);
        }
      });

      return _this;
    }

    createClass(LinkageContext, [{
      key: "render",
      value: function render() {
        return React__default.createElement(IOInputLinkageContext.Provider, {
          value: {
            register: this.register,
            unregister: this.unregister
          }
        }, this.props.children);
      }
    }]);

    return LinkageContext;
  }(React__default.Component);

  /** 
   * Global IOForms library error class to indicate the library processess that an Input has encountered
   * an invalid state due to validation fail or another synthetic error 
   * */

  var InputError =
  /*#__PURE__*/
  function () {
    createClass(InputError, null, [{
      key: "throw",

      /** 
       * Shortcut static function to throw an Input Error 
       * @param {string} message Message for the IOInput
       * @param {Array<string>|string} [names] Name(s) of the fields that this InputError targets. If no name is given, it will target all IOInputs within a IOForm
       * @param {Object} [data] Any other additional data you want to include in the error. When generated by the library this data includes the value
       * @static
       * */
      value: function _throw(message) {
        var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        throw new InputError(message, names, data);
      }
      /** 
       * @param {string} message Message for the IOInput
       * @param {Array<string>|string} [names] Name(s) of the fields that this InputError targets. If no name is given, it will target all IOInputs within a IOForm
       * @param {Object} [data] Any other additional data you want to include in the error. When generated by the library this data includes the value
       * */

    }]);

    function InputError(message) {
      var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      classCallCheck(this, InputError);

      this._names = names ? _$1__default.isArray(names) ? names : [names] : null;
      this._message = message;
      this._data = data;
    }
    /** 
     * Returns the array of IOInput names for this InputError 
     * @return {Array<string>}
     * */


    createClass(InputError, [{
      key: "names",
      value: function names() {
        return this._names;
      }
      /** 
       * Returns the first name of IOInput names for this InputError 
       * @return {string}
       * */

    }, {
      key: "name",
      value: function name() {
        return this._names[0];
      }
      /** 
       * Returns if the InputError list of names includes the given IOInput name
       * @return {boolean}
       * */

    }, {
      key: "includes",
      value: function includes(field) {
        return this._names ? this._names.includes(field) : false;
      }
      /** 
       * Returns the message for this InputError 
       * @return {string}
       * */

    }, {
      key: "message",
      value: function message() {
        return this._message;
      }
      /** 
       * Returns the array of IOInput names for this InputError 
       * @return {string}
       * @override
       * */

    }, {
      key: "toString",
      value: function toString() {
        return this._message;
      }
    }]);

    return InputError;
  }();
  var EmptyValueError =
  /*#__PURE__*/
  function (_InputError) {
    inherits(EmptyValueError, _InputError);

    function EmptyValueError() {
      classCallCheck(this, EmptyValueError);

      return possibleConstructorReturn(this, getPrototypeOf(EmptyValueError).apply(this, arguments));
    }

    return EmptyValueError;
  }(InputError);

  var SkipFieldError = function SkipFieldError() {
    classCallCheck(this, SkipFieldError);
  };

  var IOInputCollectorContext = React.createContext(null);
  /** Collects the information for any child node of type IOInput */

  var IOForm =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(IOForm, _React$PureComponent);

    function IOForm(props) {
      var _this;

      classCallCheck(this, IOForm);

      _this = possibleConstructorReturn(this, getPrototypeOf(IOForm).call(this, props));

      defineProperty(assertThisInitialized(_this), "fields", {});

      defineProperty(assertThisInitialized(_this), "validitymap", {});

      defineProperty(assertThisInitialized(_this), "lock", false);

      defineProperty(assertThisInitialized(_this), "validity", false);

      defineProperty(assertThisInitialized(_this), "onSubmit",
      /*#__PURE__*/
      function () {
        var _ref = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee(e) {
          var _this$props, onSubmit, reset, values, submitResult;

          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$props = _this.props, onSubmit = _this$props.onSubmit, reset = _this$props.reset;
                  e.preventDefault();

                  if (_this.lock) {
                    _context.next = 20;
                    break;
                  }

                  _this.lock = true;
                  _context.next = 6;
                  return _this.collect();

                case 6:
                  values = _context.sent;

                  if (!values) {
                    _context.next = 19;
                    break;
                  }

                  _context.prev = 8;
                  submitResult = onSubmit(values);

                  if (!(submitResult instanceof Promise)) {
                    _context.next = 13;
                    break;
                  }

                  _context.next = 13;
                  return submitResult;

                case 13:
                  reset && _this.reset();
                  _context.next = 19;
                  break;

                case 16:
                  _context.prev = 16;
                  _context.t0 = _context["catch"](8);

                  if (_context.t0 instanceof InputError) {
                    _this.notify(_context.t0);
                  } else {
                    console.error(_context.t0);
                  }

                case 19:
                  _this.lock = false;

                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[8, 16]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());

      defineProperty(assertThisInitialized(_this), "register", function (name, controller) {
        _this.fields[name] = controller;
      });

      defineProperty(assertThisInitialized(_this), "unregister", function (name) {
        delete _this.fields[name];
      });

      defineProperty(assertThisInitialized(_this), "reset",
      /*#__PURE__*/
      asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee2() {
        var i;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = regenerator.keys(_this.fields);

              case 1:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 7;
                  break;
                }

                i = _context2.t1.value;
                _context2.next = 5;
                return _this.fields[i].reset();

              case 5:
                _context2.next = 1;
                break;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));

      defineProperty(assertThisInitialized(_this), "setValidity", function (name, state) {
        _this.validitymap[name] = state;

        _this.checkValidities();
      });

      defineProperty(assertThisInitialized(_this), "checkValidities", function () {
        var onValidity = _this.props.onValidity;

        if (onValidity) {
          var validity = Object.keys(_this.fields).every(function (k) {
            return !!_this.validitymap[k];
          });

          if (_this.validity !== validity) {
            _this.validity = validity;
            onValidity(validity);
          }
        }
      });

      defineProperty(assertThisInitialized(_this), "onReset", function (e) {
        e.preventDefault();
        e.stopPropagation();
        !_this.lock && _this.reset();
      });

      _this.lock = !!props.lock;
      return _this;
    }

    createClass(IOForm, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.lock = this.props.lock;
      }
    }, {
      key: "serializeInto",
      value: function serializeInto(obj, name, value) {
        if (obj instanceof FormData) {
          obj.append(name, value);
          return obj;
        } else if (_.isPlainObject(obj)) {
          return _$1.set(obj, name, value);
        }
      }
    }, {
      key: "collect",
      value: function () {
        var _collect = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee3() {
          var formdata, values, fail, i, field, v;
          return regenerator.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  formdata = this.props.formdata;
                  values = formdata ? new FormData() : {};
                  fail = false;
                  _context3.t0 = regenerator.keys(this.fields);

                case 4:
                  if ((_context3.t1 = _context3.t0()).done) {
                    _context3.next = 19;
                    break;
                  }

                  i = _context3.t1.value;
                  _context3.prev = 6;
                  field = this.fields[i];
                  _context3.next = 10;
                  return field.collect(true);

                case 10:
                  v = _context3.sent;
                  values = this.serializeInto(values, i, v);
                  _context3.next = 17;
                  break;

                case 14:
                  _context3.prev = 14;
                  _context3.t2 = _context3["catch"](6);

                  if (_context3.t2 instanceof InputError) {
                    fail = true;
                    this.notify(_context3.t2);
                  } else if (!(_context3.t2 instanceof SkipFieldError)) {
                    console.error(_context3.t2);
                  }

                case 17:
                  _context3.next = 4;
                  break;

                case 19:
                  return _context3.abrupt("return", fail ? null : values);

                case 20:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[6, 14]]);
        }));

        function collect() {
          return _collect.apply(this, arguments);
        }

        return collect;
      }()
    }, {
      key: "notify",
      value: function () {
        var _notify = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee4(e) {
          var i;
          return regenerator.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.t0 = regenerator.keys(this.fields);

                case 1:
                  if ((_context4.t1 = _context4.t0()).done) {
                    _context4.next = 7;
                    break;
                  }

                  i = _context4.t1.value;
                  _context4.next = 5;
                  return this.fields[i].notify(e);

                case 5:
                  _context4.next = 1;
                  break;

                case 7:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function notify(_x2) {
          return _notify.apply(this, arguments);
        }

        return notify;
      }()
    }, {
      key: "render",
      value: function render() {
        var innerProps = this.props.innerProps;
        return React.createElement(MessageContext, null, React.createElement(LinkageContext, null, React.createElement(IOInputCollectorContext.Provider, {
          value: {
            register: this.register,
            unregister: this.unregister,
            setValidity: this.setValidity
          }
        }, React.createElement("form", _extends_1({
          className: "iof-main",
          onReset: this.onReset,
          id: this.props.id || undefined,
          onSubmit: this.onSubmit
        }, innerProps), React.createElement("button", {
          style: {
            display: 'none'
          }
        }), this.props.children))));
      }
    }]);

    return IOForm;
  }(React.PureComponent);

  defineProperty(IOForm, "propTypes", {
    /** Sets the id of the form tag element */
    id: PropTypes.string,

    /** Triggered when a IOInput type submit is clicked within the tree */
    onSubmit: PropTypes.func,

    /** When true the form will not perform any submit. Useful to block any subsecuent submit after the first one */
    lock: PropTypes.bool,

    /** Indicates that the form should reset after a successfull submit */
    reset: PropTypes.bool,

    /** Indicates that the data should be serialized as a FormData object */
    formdata: PropTypes.bool,

    /** Triggered when validity changes; all the fields have achieved validity (true) or one them of them hasn't (false) */
    onValidity: PropTypes.func,

    /** Send props to the form JSX element */
    innerProps: PropTypes.object
  });

  defineProperty(IOForm, "defaultProps", {
    lock: false,
    reset: false,
    formdata: false
  });

  var IOInputValidatorContext = React.createContext(null);
  /** Collects the information for any child node of type IOInput */

  var ValidatorContext =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(ValidatorContext, _React$PureComponent);

    function ValidatorContext() {
      classCallCheck(this, ValidatorContext);

      return possibleConstructorReturn(this, getPrototypeOf(ValidatorContext).apply(this, arguments));
    }

    createClass(ValidatorContext, [{
      key: "render",
      value: function render() {
        return React.createElement(IOInputValidatorContext.Provider, {
          value: this.props
        }, this.props.children);
      }
    }]);

    return ValidatorContext;
  }(React.PureComponent);
  ValidatorContext.propTypes = {
    /** Object that contains as key:string-value:(RegExp|Function) pair the set of messages for each validation */
    validations: PropTypes.object.isRequired,

    /** Default message to show in case a message is not defined. */
    defaultMessage: PropTypes.string,

    /** Default message to show in case an Input fails the required validation */
    requiredMessage: PropTypes.string,

    /** Object that contains as key:string-value:string pair the set of messages for each validation */
    messages: PropTypes.object
  };

  var InputFactory =
  /*#__PURE__*/
  function () {
    function InputFactory() {
      classCallCheck(this, InputFactory);
    }

    createClass(InputFactory, null, [{
      key: "register",

      /** Components registry to be used  */

      /**
      * Registers a new entry object into the provided registry
      * @param {string} registry Registry name
      * @param {Array<string>} entry Entry object consisting of <b>{ type: string, component: ReactElement }</b>
      */
      value: function register(registry, entry) {
        if (registry && entry && entry.length) {
          if (!InputFactory.registry[registry]) {
            InputFactory.registry[registry] = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = entry[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var reg = _step.value;
                InputFactory.add(registry, reg.type, reg.component);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }

          return entry;
        }

        InputFactory.registry[registry];
        throw new Error("[IOInput]InputFactory::register Given params registry(".concat(registry, ") and entry(").concat(entry, ") cannot be null or empty."));
      }
      /**
      * Adds a new component of type input to be rendered into the Given registry
      * @param {string} registry Registry name into which the component will be registered
      * @param {Array|string} type Type (or Array of types) to which associate your component to
      * @param {ReactElement} Component your given component
      */

    }, {
      key: "add",
      value: function add(registry, type, Component) {
        if (registry && type && type.length) {
          if (!InputFactory.registry[registry]) {
            InputFactory.registry[registry] = {};
          }

          if (_$1__default.isString(type)) {
            var current = InputFactory.registry[registry][type];

            if (current) {
              console.warn("[IOInput]InputFactory::add Given type \"".concat(type, "\" was already in registry for ").concat(current, ". Overriding for ").concat(Component));
            }

            InputFactory.registry[registry][type] = Component;
          } else if (_$1__default.isArray(type)) {
            type.forEach(function (k) {
              InputFactory.add(registry, k, Component);
            });
          }
        } else {
          throw new Error("[IOInput]InputFactory::add Given param type cannot be null or empty");
        }

        return Component;
      }
      /**
      * Delivers to the invoker a new component instance chosen by the given key and injected with the given props
      * @param {string} type Type of the input
      */

    }, {
      key: "get",
      value: function get(type) {
        var registry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
        var Component = InputFactory.registry[registry] ? InputFactory.registry[registry][type] : null;

        if (!Component) {
          Component = InputFactory.registry['default'][type];
        }

        if (!Component) {
          Component = InputFactory.registry[registry]['default'];
          console.warn("[IOInput]InputFactory::render No Component available for the given type ".concat(type, " at registry ").concat(registry, ". Falling to default type"));
        }

        return Component;
      }
    }]);

    return InputFactory;
  }();

  defineProperty(InputFactory, "registry", {});

  var IOInputRegistryContext = React__default.createContext(null);
  /** Collects the information for any child node of type IOInput */

  var RegistryContext =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(RegistryContext, _React$PureComponent);

    function RegistryContext(props) {
      var _this;

      classCallCheck(this, RegistryContext);

      _this = possibleConstructorReturn(this, getPrototypeOf(RegistryContext).call(this, props));
      InputFactory.register(props.name, props.entry);
      return _this;
    }

    createClass(RegistryContext, [{
      key: "render",
      value: function render() {
        var main = this.props.main;
        return React__default.createElement(React.Fragment, null, main ? React__default.createElement(IOInputRegistryContext.Provider, {
          value: this.props.name
        }, this.props.children) : this.props.children);
      }
    }]);

    return RegistryContext;
  }(React__default.PureComponent);
  RegistryContext.propTypes = {
    /** Name of the registry to use for all the child node IOInput's in the tree */
    name: PropTypes.string.isRequired,

    /** Entries to add to the registry */
    entry: PropTypes.array.isRequired,

    /** Indicates that the entry will be the default entry to take when a IOInput is invoked */
    main: PropTypes.bool
  };
  RegistryContext.defaultProps = {
    main: false
  };

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var objectWithoutProperties = _objectWithoutProperties;

  var singlePend = function singlePend(pend) {
    return React__default.createElement("div", {
      className: "input-group-text"
    }, pend);
  };

  var pendRender = function pendRender(pend) {
    if (_.isArray(pend)) {
      return pend.map(function (p) {
        return singlePend(p);
      });
    }

    return singlePend(pend);
  };

  var classes = function classes(_ref) {
    var valid = _ref.valid,
        invalid = _ref.invalid;
    var feedbackClass = invalid ? 'text-danger' : valid ? 'text-success' : 'text-muted';
    var fieldClass = invalid ? 'is-invalid' : valid ? 'is-valid' : '';
    return {
      fieldClass: fieldClass,
      feedbackClass: feedbackClass
    };
  };

  var extractOptions = function extractOptions(props) {
    var children = props.children;
    var options = props.ioProps.options;

    if (!options) {
      var synOptions = [];
      React__default.Children.forEach(children, function (element) {
        if (!React__default.isValidElement(element)) return;
        var _element$props = element.props,
            value = _element$props.value,
            label = _element$props.children;
        value && synOptions.push({
          value: value,
          label: label
        });
      });
      return synOptions;
    } else {
      return options;
    }
  };

  var wrapper = function wrapper(Component, props) {
    var type = props.ioProps.type;

    switch (type) {
      case 'radio':
        return wrapperRadioGroup(Component, props);

      case 'checkbox':
        return wrapperCheckGroup(Component, props);

      default:
        return wrapperInputGroup(Component, props);
    }
  };

  var wrapperRadioGroup = function wrapperRadioGroup(Component, props) {
    var prepend = props.prepend,
        append = props.append,
        label = props.label,
        inline = props.inline,
        className = props.className,
        value = props.value,
        setValue = props.setValue,
        children = props.children,
        ioProps = props.ioProps,
        rest = objectWithoutProperties(props, ["prepend", "append", "label", "inline", "className", "value", "setValue", "children", "ioProps"]);

    var name = ioProps.name,
        message = ioProps.message;

    var _classes = classes(props.ioProps),
        fieldClass = _classes.fieldClass,
        feedbackClass = _classes.feedbackClass;

    var options = extractOptions(props);
    var inlineClasses = !!inline ? 'col-12' : undefined;
    return React__default.createElement(React.Fragment, null, label && React__default.createElement("label", {
      className: inlineClasses
    }, label), React__default.createElement("div", {
      className: inlineClasses
    }, options.map(function (option) {
      return React__default.createElement("div", {
        key: "radio_".concat(name, "_").concat(option.value.toString()),
        className: "form-check".concat(!!inline ? '-inline' : '')
      }, React__default.createElement("label", {
        className: "form-check-label"
      }, React__default.createElement("input", _extends_1({
        id: "radio_".concat(name, "_").concat(option.value.toString()),
        className: "form-check-input ".concat(fieldClass, " ").concat(className || ''),
        type: "radio",
        value: option.value,
        onChange: function onChange(e) {
          return setValue(option.value);
        },
        checked: option.value === value
      }, rest)), option.label), message && React__default.createElement("small", {
        className: "form-text ".concat(feedbackClass)
      }, rest.ioProps.message));
    })));
  };

  var wrapperCheckGroup = function wrapperCheckGroup(Component, props) {
    var prepend = props.prepend,
        append = props.append,
        label = props.label,
        inline = props.inline,
        className = props.className,
        rest = objectWithoutProperties(props, ["prepend", "append", "label", "inline", "className"]);

    var _classes2 = classes(props.ioProps),
        fieldClass = _classes2.fieldClass,
        feedbackClass = _classes2.feedbackClass;

    return React__default.createElement("div", {
      className: "form-check".concat(!!inline ? '-inline' : '')
    }, React__default.createElement("label", {
      className: "form-check-label"
    }, React__default.createElement(Component, _extends_1({
      className: "form-check-input ".concat(fieldClass, " ").concat(className || '')
    }, rest)), label), rest.ioProps.message && React__default.createElement("small", {
      className: "form-text ".concat(feedbackClass)
    }, rest.ioProps.message));
  };

  var wrapperInputGroup = function wrapperInputGroup(Component, props) {
    var prepend = props.prepend,
        append = props.append,
        label = props.label,
        inline = props.inline,
        className = props.className,
        rest = objectWithoutProperties(props, ["prepend", "append", "label", "inline", "className"]);

    var _classes3 = classes(props.ioProps),
        fieldClass = _classes3.fieldClass,
        feedbackClass = _classes3.feedbackClass;

    var _ref2 = inline || {
      label: '',
      input: ''
    },
        _ref2$label = _ref2.label,
        labelClass = _ref2$label === void 0 ? 'col' : _ref2$label,
        _ref2$input = _ref2.input,
        inputClass = _ref2$input === void 0 ? 'col' : _ref2$input;

    return React__default.createElement(React.Fragment, null, label && React__default.createElement("label", {
      className: labelClass,
      htmlFor: rest.id || rest.name
    }, label), React__default.createElement("div", {
      className: "input-group ".concat(inputClass)
    }, !!prepend && React__default.createElement("div", {
      className: "input-group-prepend"
    }, pendRender(prepend)), React__default.createElement(Component, _extends_1({
      className: "form-control ".concat(fieldClass, " ").concat(className || '').trim()
    }, rest)), !!append && React__default.createElement("div", {
      className: "input-group-append"
    }, pendRender(append))), rest.ioProps.message && React__default.createElement("small", {
      className: "form-text ".concat(feedbackClass, " ").concat(!!inline ? 'col-12 text-right' : '')
    }, rest.ioProps.message));
  };

  function layouter(Component, props) {
    var inline = props.inline;
    return React__default.createElement("div", {
      className: "form-group ".concat(!!inline ? 'row' : '')
    }, wrapper(Component, props));
  }

  var defaultLayouter = function defaultLayouter(Component, props) {
    return React__default.createElement(Component, props);
  };
  var IOInputLayoutContext = React__default.createContext(defaultLayouter);
  var LayoutContext =
  /*#__PURE__*/
  function (_React$Component) {
    inherits(LayoutContext, _React$Component);

    function LayoutContext() {
      var _getPrototypeOf2;

      var _this;

      classCallCheck(this, LayoutContext);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(LayoutContext)).call.apply(_getPrototypeOf2, [this].concat(args)));

      defineProperty(assertThisInitialized(_this), "state", {
        layouter: defaultLayouter
      });

      return _this;
    }

    createClass(LayoutContext, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var layouter$1 = this.props.layouter;

        if (_$1__default.isFunction(layouter$1)) {
          this.setState({
            layouter: layouter$1
          });
        } else if (_$1__default.isString(layouter$1)) {
          switch (layouter$1) {
            case 'Bootstrap4':
              return this.setState({
                layouter: layouter
              });

            default:
              return this.setState({
                layouter: defaultLayouter
              });
          }
        } else {
          throw new Error("[ReactIOForms::Invalid provided layouter] given: ".concat(layouter$1));
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(IOInputLayoutContext.Provider, {
          value: this.state.layouter
        }, this.props.children);
      }
    }]);

    return LayoutContext;
  }(React__default.Component);

  defineProperty(LayoutContext, "propTypes", {
    /** Name of the available Layouter of your choosing */
    layouter: PropTypes__default.oneOfType([PropTypes__default.oneOf(['Bootstrap4']), PropTypes__default.func]).isRequired
  });

  /** Extracts a subset of messages specified by certain prefix */
  function getMessagesFromIntl(intlmessages, prefix) {
    var removePrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (intlmessages) {
      var keys = Object.keys(intlmessages).filter(function (k) {
        return k.indexOf(prefix) === 0;
      });

      var validationMessages = _.pick(intlmessages, keys);

      if (removePrefix) {
        return _.mapKeys(validationMessages, function (v, k) {
          return k.replace(prefix, '');
        });
      }

      return validationMessages;
    }

    return null;
  }
  /** Includes only the props from the given props by the coincidence in the list */

  function include(props, list) {
    return _.pick(props, Object.keys(list));
  }
  /** Excludes the props from the given props by the coincidence in the list */

  function exclude(props, list) {
    return _.omit(props, Object.keys(list));
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  var superPropBase = _superPropBase;

  var get = createCommonjsModule(function (module) {
  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      module.exports = _get = Reflect.get;
    } else {
      module.exports = _get = function _get(target, property, receiver) {
        var base = superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  module.exports = _get;
  });

  var Observable =
  /*#__PURE__*/
  function () {
    function Observable() {
      classCallCheck(this, Observable);

      defineProperty(this, "observers", []);
    }

    createClass(Observable, [{
      key: "add",
      value: function add(observer) {
        this.observers.push(observer);
      }
    }, {
      key: "notify",
      value: function notify(obj) {
        var promises = this.observers.map(
        /*#__PURE__*/
        function () {
          var _ref = asyncToGenerator(
          /*#__PURE__*/
          regenerator.mark(function _callee(observer) {
            return regenerator.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", observer(obj));

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        return Promise.all(promises);
      }
    }]);

    return Observable;
  }();

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  /** Core Component of the IOForms Library. This component renders the real input */

  var ProxyInput =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(ProxyInput, _React$PureComponent);

    function ProxyInput(props) {
      var _this;

      classCallCheck(this, ProxyInput);

      _this = possibleConstructorReturn(this, getPrototypeOf(ProxyInput).call(this, props));

      defineProperty(assertThisInitialized(_this), "observer", new Observable());

      defineProperty(assertThisInitialized(_this), "controllerReference", null);

      defineProperty(assertThisInitialized(_this), "Component", null);

      defineProperty(assertThisInitialized(_this), "state", {});

      defineProperty(assertThisInitialized(_this), "mounted", false);

      defineProperty(assertThisInitialized(_this), "setValidity", function (state) {
        var contextProps = _this.props.contextProps;
        var name = _this.props.ioProps.name;

        _$1__default.defer(function () {
          var setValidity = _$1__default.get(contextProps, 'form.setValidity');

          setValidity(name, state);
        });
      });

      defineProperty(assertThisInitialized(_this), "runcycle",
      /*#__PURE__*/
      asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee() {
        var _this$props$ioProps, onValue, name, value, val;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props$ioProps = _this.props.ioProps, onValue = _this$props$ioProps.onValue, name = _this$props$ioProps.name;
                value = _this.state.value;
                _context.prev = 2;
                _context.next = 5;
                return _this.collect();

              case 5:
                val = _context.sent;
                onValue && onValue(val, name, {
                  originalValue: value
                });

                _this.setValidity(true);

                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);

                _this.setValidity(false);

                throw _context.t0;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10]]);
      })));

      defineProperty(assertThisInitialized(_this), "inject", function (value, origin) {
        var filteredValue = _this.filterIn(value, origin);

        return new Promise(function (resolve) {
          _this.setValue(filteredValue, function () {
            resolve();
          });
        });
      });

      defineProperty(assertThisInitialized(_this), "observe",
      /*#__PURE__*/
      function () {
        var _ref2 = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee2(caller) {
          return regenerator.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", _this.observer.add(caller));

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());

      defineProperty(assertThisInitialized(_this), "collect",
      /*#__PURE__*/
      asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee3() {
        var strict,
            value,
            _this$props$ioProps2,
            validate,
            validMessage,
            onValid,
            exclude,
            include,
            shouldNotfityValidity,
            val,
            _args3 = arguments;

        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                strict = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
                value = _this.state.value;
                _this$props$ioProps2 = _this.props.ioProps, validate = _this$props$ioProps2.validate, validMessage = _this$props$ioProps2.validMessage, onValid = _this$props$ioProps2.onValid, exclude = _this$props$ioProps2.exclude, include = _this$props$ioProps2.include;
                shouldNotfityValidity = !!validate && !_this.isEmptyValue(value);
                _context3.next = 6;
                return _this.verify(value, validate);

              case 6:
                !strict && _$1__default.defer(function () {
                  _this.sendMessage('');

                  _this.setState({
                    message: '',
                    invalid: false,
                    valid: shouldNotfityValidity
                  });

                  shouldNotfityValidity && validMessage && _this.info(validMessage);
                  shouldNotfityValidity && onValid && onValid(val);
                });
                val = _this.filterOut(value);

                if (!(strict && (exclude || !include && _this.isEmptyValue(val)))) {
                  _context3.next = 10;
                  break;
                }

                throw new SkipFieldError();

              case 10:
                return _context3.abrupt("return", val);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));

      defineProperty(assertThisInitialized(_this), "notify",
      /*#__PURE__*/
      function () {
        var _ref4 = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee4(message) {
          var _this$props$ioProps3, onInvalid, name;

          return regenerator.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this$props$ioProps3 = _this.props.ioProps, onInvalid = _this$props$ioProps3.onInvalid, name = _this$props$ioProps3.name;

                  if (!message) {
                    _context4.next = 13;
                    break;
                  }

                  if (!(message instanceof InputError)) {
                    _context4.next = 8;
                    break;
                  }

                  if (!(!message.names() || message.includes(name))) {
                    _context4.next = 6;
                    break;
                  }

                  _$1__default.defer(function () {
                    _this.setState({
                      message: message.toString(),
                      invalid: true,
                      valid: false
                    });

                    onInvalid && onInvalid(message, name);
                  });

                  return _context4.abrupt("return", _this.error(message.toString(), message));

                case 6:
                  _context4.next = 13;
                  break;

                case 8:
                  if (!(message instanceof Error)) {
                    _context4.next = 12;
                    break;
                  }

                  console.error(message);
                  _context4.next = 13;
                  break;

                case 12:
                  return _context4.abrupt("return", _this.info(message.toString()));

                case 13:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());

      defineProperty(assertThisInitialized(_this), "filterIn", function (value) {
        var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _this$props$ioProps4 = _this.props.ioProps,
            filterIn = _this$props$ioProps4.filterIn,
            name = _this$props$ioProps4.name;
        var currentValue = _this.state.value;
        return filterIn ? filterIn(value, origin || name, currentValue) : value;
      });

      defineProperty(assertThisInitialized(_this), "filterOut", function (value) {
        var filterOut = _this.props.ioProps.filterOut;
        return filterOut ? filterOut(value) : value;
      });

      defineProperty(assertThisInitialized(_this), "setValue", function (value) {
        var onChange = _this.props.ioProps.onChange;

        _$1__default.defer(function () {
          onChange && onChange(value);
        });

        return new Promise(function (res) {
          _this.setState({
            value: value
          }, function () {
            res(value);
          });
        }).then(
        /*#__PURE__*/
        function () {
          var _ref5 = asyncToGenerator(
          /*#__PURE__*/
          regenerator.mark(function _callee5(value) {
            return regenerator.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this.runcycle();

                  case 2:
                    _this.observer.notify({
                      value: _this.filterOut(value),
                      ioProps: _this.props.ioProps
                    });

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));

          return function (_x3) {
            return _ref5.apply(this, arguments);
          };
        }())["catch"](function (e) {
          _this.notify(e);

          _this.observer.notify({
            value: _this.filterOut(value),
            ioProps: _this.props.ioProps,
            error: e
          }); // throw e

        });
      });

      defineProperty(assertThisInitialized(_this), "info", function (message) {
        var value = _this.state.value;

        _this.setState({
          message: message
        });

        _this.sendMessage(message, value);
      });

      defineProperty(assertThisInitialized(_this), "error", function (message, inputError) {
        var value = _this.state.value;

        _this.setState({
          message: message
        });

        _this.sendMessage(message, value, inputError);
      });

      defineProperty(assertThisInitialized(_this), "reset", function () {
        var emptyValue = _$1__default.get(_this.Component, 'emptyValue', '');

        var defaultValue = _$1__default.get(_this.props, 'ioProps.defaultValue');

        var dval = _$1__default.isFunction(defaultValue) ? defaultValue() : defaultValue;

        _this.setState({
          value: dval || emptyValue,
          valid: false,
          invalid: false
        });

        _this.clearMessage();
      });

      _this.Component = InputFactory.get(_$1__default.get(props, 'ioProps.type', 'default'), _$1__default.get(props, 'contextProps.registry', 'default'));
      _this.state = {
        value: _this.getInitialValue(props),
        invalid: _$1__default.get(props, 'ioProps.invalid', false),
        valid: _$1__default.get(props, 'ioProps.valid', false),
        message: ''
      };
      _this.controllerReference = {
        observe: _this.observe,
        collect: _this.collect,
        notify: _this.notify,
        inject: _this.inject,
        reset: _this.reset,
        props: function props() {
          return _this.props;
        }
      };
      return _this;
    }

    createClass(ProxyInput, [{
      key: "componentDidUpdate",
      value: function () {
        var _componentDidUpdate = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee6(prevProps) {
          var prevValue, curValue, value, shouldrun;
          return regenerator.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  prevValue = _$1__default.get(prevProps, 'ioProps.value');
                  curValue = _$1__default.get(this.props, 'ioProps.value');
                  value = this.state.value;
                  shouldrun = false;

                  if (!(!this.isEqual(prevValue, curValue) && !this.isEqual(curValue, value))) {
                    _context6.next = 8;
                    break;
                  }

                  _context6.next = 7;
                  return this.setValue(this.filterIn(curValue));

                case 7:
                  shouldrun = true;

                case 8:
                  if (prevProps.ioProps.required !== this.props.ioProps.required) {
                    shouldrun = true;
                  }

                  if (shouldrun) {
                    this.runInitialValue();
                  }

                  if (prevProps && prevProps.ioProps.message !== this.props.ioProps.message) {
                    if (this.props.ioProps.message) {
                      if (this.props.ioProps.invalid) {
                        this.error(this.props.ioProps.message);
                      } else {
                        this.info(this.props.ioProps.message);
                      }
                    } else {
                      this.clearMessage();
                    }
                  }

                  if (prevProps && prevProps.ioProps.invalid !== this.props.ioProps.invalid) {
                    this.setState({
                      invalid: !!this.props.ioProps.invalid
                    });
                  }

                  if (prevProps && prevProps.ioProps.valid !== this.props.ioProps.valid) {
                    this.setState({
                      valid: !!this.props.ioProps.valid
                    });
                  }

                case 13:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function componentDidUpdate(_x4) {
          return _componentDidUpdate.apply(this, arguments);
        }

        return componentDidUpdate;
      }()
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var contextProps = this.props.contextProps;
        var name = this.props.ioProps.name;
        this.mounted = true;

        if (this.validProps(this.props)) {
          var form = _$1__default.get(contextProps, 'form.register');

          var linkage = _$1__default.get(contextProps, "linkage.register");

          form && form(name, this.controllerReference);
          linkage && linkage(name, this.controllerReference);
        }

        this.runInitialValue();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var contextProps = this.props.contextProps;
        var name = this.props.ioProps.name;
        this.mounted = false;

        var form = _$1__default.get(contextProps, 'form.unregister');

        var linkage = _$1__default.get(contextProps, "linkage.unregister");

        form && form(name, this.controllerReference);
        linkage && linkage(name, this.controllerReference);
        this.observer = new Observable();
      }
    }, {
      key: "setState",
      value: function setState() {
        if (this.mounted) {
          var _get2;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          (_get2 = get(getPrototypeOf(ProxyInput.prototype), "setState", this)).call.apply(_get2, [this].concat(args));
        }
      }
    }, {
      key: "runInitialValue",
      value: function () {
        var _runInitialValue = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee7() {
          var _this$props$ioProps5, required, validate, value;

          return regenerator.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _this$props$ioProps5 = this.props.ioProps, required = _this$props$ioProps5.required, validate = _this$props$ioProps5.validate;
                  value = this.state.value;
                  /*
                   * Added a case where an input changes it's required prop to true,
                   * so the form gets a notification if it's valid with this new component
                  */

                  if (!(required && this.isEmptyValue(value))) {
                    _context7.next = 6;
                    break;
                  }

                  this.setValidity(false);
                  this.clearMessage();
                  return _context7.abrupt("return");

                case 6:
                  if (!(!required && this.isEmptyValue(value))) {
                    _context7.next = 11;
                    break;
                  }

                  this.setValidity(true);
                  this.clearMessage();
                  _context7.next = 21;
                  break;

                case 11:
                  if (this.isEmptyValue(value)) {
                    _context7.next = 21;
                    break;
                  }

                  _context7.prev = 12;
                  _context7.next = 15;
                  return this.verify(value, validate);

                case 15:
                  this.setValidity(true);
                  this.clearMessage();
                  _context7.next = 21;
                  break;

                case 19:
                  _context7.prev = 19;
                  _context7.t0 = _context7["catch"](12);

                case 21:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this, [[12, 19]]);
        }));

        function runInitialValue() {
          return _runInitialValue.apply(this, arguments);
        }

        return runInitialValue;
      }()
    }, {
      key: "getInitialValue",
      value: function getInitialValue(props) {
        var value = this.filterIn(_$1__default.get(props, 'ioProps.value'));

        var defaultValue = _$1__default.get(this.props, 'ioProps.defaultValue');

        if (value === undefined || value === null) {
          if (defaultValue) {
            value = defaultValue;
          } else {
            value = this.Component.emptyValue !== undefined ? this.Component.emptyValue : '';
          }
        }

        return value;
      }
    }, {
      key: "validProps",
      value: function validProps(props) {
        var ioProps = props.ioProps;

        if (!_$1__default.get(ioProps, 'name')) {
          throw new Error('IOForms::Input name cannot be null or empty');
        }

        return true;
      }
    }, {
      key: "isEqual",
      value: function isEqual(val1, val2) {
        var equality = _$1__default.get(this.Component, 'isEqual') || _$1__default.isEqual;

        return equality(val1, val2);
      }
    }, {
      key: "isEmptyValue",
      value: function isEmptyValue(value) {
        var emptyValue = _$1__default.get(this.Component, 'emptyValue', '');

        return value === null || value === undefined || value === '' || this.isEqual(value, emptyValue);
      }
    }, {
      key: "verify",
      value: function () {
        var _verify = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee8(value, validate) {
          var validation, _this$props$ioProps6, required, name, invalidMessage, defaultMessage, requiredMessage, validator, isEmpty, _validator, valid, message;

          return regenerator.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  validation = this.props.contextProps.validation;
                  _this$props$ioProps6 = this.props.ioProps, required = _this$props$ioProps6.required, name = _this$props$ioProps6.name, invalidMessage = _this$props$ioProps6.invalidMessage;
                  defaultMessage = _$1__default.get(validation, 'defaultMessage');
                  requiredMessage = _$1__default.get(validation, 'requiredMessage');
                  validator = this.getValidationFunction(validate);
                  isEmpty = this.isEmptyValue(value);

                  if (!(required && isEmpty)) {
                    _context8.next = 10;
                    break;
                  }

                  throw new EmptyValueError(invalidMessage || requiredMessage, name, {
                    value: value
                  });

                case 10:
                  if (!(validate && !isEmpty)) {
                    _context8.next = 15;
                    break;
                  }

                  _validator = validator(value), valid = _validator.valid, message = _validator.message;

                  if (!valid) {
                    _context8.next = 14;
                    break;
                  }

                  return _context8.abrupt("return", value);

                case 14:
                  throw new InputError(invalidMessage || message || defaultMessage, name, {
                    value: value
                  });

                case 15:
                  return _context8.abrupt("return", value);

                case 16:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function verify(_x5, _x6) {
          return _verify.apply(this, arguments);
        }

        return verify;
      }()
    }, {
      key: "getValidationFunction",
      value: function getValidationFunction(validate) {
        var _this2 = this;

        var proxymessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var validation = this.props.contextProps.validation;
        var message = _$1__default.get(validation, "messages.".concat(validate)) || proxymessage;

        if (_$1__default.isArray(validate)) {
          var validations = validate.map(function (v) {
            return _this2.getValidationFunction(v);
          });
          return function (value) {
            var results = validations.map(function (v) {
              return v(value);
            }).filter(function (r) {
              return !r.valid;
            });

            if (results.length > 0) {
              return results[0];
            }

            return {
              valid: true
            };
          };
        } else if (_$1__default.isString(validate)) {
          var entry = _$1__default.get(validation, "validations.".concat(validate), ProxyInput.builtInValidations[validate]);

          if (!entry) {
            return function (value) {
              return {
                valid: new RegExp(validate).test(value),
                message: message
              };
            };
          } else if (_$1__default.isString(entry) || entry instanceof RegExp) {
            return function (value) {
              return {
                valid: new RegExp(entry).test(value),
                message: message
              };
            };
          } else {
            return this.getValidationFunction(entry, message);
          }
        } else if (_$1__default.isFunction(validate)) {
          return function (value) {
            var test = validate(value);

            if (_$1__default.isBoolean(test)) {
              return {
                valid: test,
                message: message
              };
            } else {
              return test;
            }
          };
        } else if (_$1__default.isBoolean(validate)) {
          return function (value) {
            return {
              valid: validate,
              message: message
            };
          };
        } else {
          return function (value) {
            return {
              valid: new RegExp(validate).test(value),
              message: message
            };
          };
        }
      }
    }, {
      key: "sendMessage",
      value: function sendMessage(message, value) {
        var _this3 = this;

        var inputError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var messages = this.props.contextProps.messages;
        var _this$props$ioProps7 = this.props.ioProps,
            onMessage = _this$props$ioProps7.onMessage,
            name = _this$props$ioProps7.name;

        _$1__default.defer(function () {
          if (!_this3.props.ignoreMessagePool) {
            messages.dispatch && messages.dispatch(message, name);
          }

          onMessage && onMessage(message, {
            value: value,
            name: name,
            error: inputError
          });
        });
      }
    }, {
      key: "clearMessage",
      value: function clearMessage() {
        var name = this.props.ioProps.name;
        var messages = this.props.contextProps.messages;
        messages.set && messages.set('', name);
        this.setState({
          message: ''
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$standardP = _this$props.standardProps,
            ignoreMessagePool = _this$props$standardP.ignoreMessagePool,
            rest = objectWithoutProperties(_this$props$standardP, ["ignoreMessagePool"]),
            ioProps = _this$props.ioProps,
            layouter = _this$props.contextProps.layouter;

        var _this$state = this.state,
            valid = _this$state.valid,
            invalid = _this$state.invalid,
            value = _this$state.value,
            message = _this$state.message;
        var Component = this.Component;
        return layouter(Component, _objectSpread({}, rest, {
          ioProps: _objectSpread({}, ioProps, {
            valid: valid,
            invalid: invalid,
            message: message
          }),
          setValue: this.setValue,
          value: value
        }));
      }
    }]);

    return ProxyInput;
  }(React.PureComponent);

  defineProperty(ProxyInput, "propTypes", {
    /** All the props derived from the React context handlers used in IOForms */
    contextProps: PropTypes__default.object,

    /** IO Unique props for the Proxy Input to consume */
    ioProps: PropTypes__default.object,

    /** Standard input props delivered by the implementor all the way to the core component */
    standardProps: PropTypes__default.object,
    ignoreMessagePool: PropTypes__default.bool
  });

  defineProperty(ProxyInput, "builtInValidations", {
    letters: /^[a-zA-Z\s]+$/,
    numbers: /^[0-9]+$/,
    numeric: /^[0-9\.,]+$/,
    email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  });

  /** Determines the bootstrap input classes by its valid and invalid values */
  function classNameByValidity(valid, invalid) {
    return "".concat(valid && !invalid ? 'valid' : '', " ").concat(invalid ? 'invalid' : '').trim();
  }
  function classNameCreate(type, valid, invalid) {
    return "iof-input iof-".concat(type, " ").concat(classNameByValidity(valid, invalid)).trim();
  }

  var TextInput =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(TextInput, _React$PureComponent);

    function TextInput() {
      classCallCheck(this, TextInput);

      return possibleConstructorReturn(this, getPrototypeOf(TextInput).apply(this, arguments));
    }

    createClass(TextInput, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$ioProps = _this$props.ioProps,
            type = _this$props$ioProps.type,
            valid = _this$props$ioProps.valid,
            invalid = _this$props$ioProps.invalid,
            message = _this$props$ioProps.message,
            name = _this$props$ioProps.name,
            setValue = _this$props.setValue,
            value = _this$props.value,
            _this$props$className = _this$props.className,
            className = _this$props$className === void 0 ? '' : _this$props$className,
            innerRef = _this$props.innerRef,
            rest = objectWithoutProperties(_this$props, ["ioProps", "setValue", "value", "className", "innerRef"]);

        return React__default.createElement("input", _extends_1({
          "data-message": message,
          className: "".concat(classNameCreate(type, valid, invalid), " ").concat(className).trim(),
          type: type,
          onChange: function onChange(e) {
            return setValue(e.target.value);
          },
          value: value,
          name: name,
          ref: innerRef
        }, rest));
      }
    }]);

    return TextInput;
  }(React__default.PureComponent);

  defineProperty(TextInput, "propTypes", {
    value: PropTypes__default.any,

    /** INJECTED FROM ProxyInput */
    ioProps: PropTypes__default.object.isRequired,

    /** INJECTED FROM ProxyInput */
    setValue: PropTypes__default.func
    /** Indicates the ProxyInput layer what value should be taken as default */

  });

  defineProperty(TextInput, "emptyValue", '');

  var FileInput =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(FileInput, _React$PureComponent);

    function FileInput() {
      var _getPrototypeOf2;

      var _this;

      classCallCheck(this, FileInput);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(FileInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

      defineProperty(assertThisInitialized(_this), "fileinput", null);

      defineProperty(assertThisInitialized(_this), "onChange", function (e) {
        var setValue = _this.props.setValue;
        var files = e.target.files;

        if (files && files.length) {
          setValue(files.length === 1 ? files[0] : files);
        }
      });

      return _this;
    }

    createClass(FileInput, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.props.value === '') {
          this.fileinput.value = '';
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            _this$props$ioProps = _this$props.ioProps,
            type = _this$props$ioProps.type,
            valid = _this$props$ioProps.valid,
            invalid = _this$props$ioProps.invalid,
            message = _this$props$ioProps.message,
            name = _this$props$ioProps.name,
            setValue = _this$props.setValue,
            value = _this$props.value,
            _this$props$className = _this$props.className,
            className = _this$props$className === void 0 ? '' : _this$props$className,
            innerRef = _this$props.innerRef,
            rest = objectWithoutProperties(_this$props, ["ioProps", "setValue", "value", "className", "innerRef"]);

        return React__default.createElement("input", _extends_1({
          "data-message": message,
          className: "".concat(classNameCreate(type, valid, invalid), " ").concat(className).trim(),
          name: name,
          type: type,
          ref: function ref(e) {
            _this2.fileinput = e;
          },
          onChange: this.onChange
        }, rest));
      }
    }]);

    return FileInput;
  }(React__default.PureComponent);

  defineProperty(FileInput, "propTypes", {
    value: PropTypes__default.any,

    /** INJECTED FROM ProxyInput */
    ioProps: PropTypes__default.object.isRequired,

    /** INJECTED FROM ProxyInput */
    setValue: PropTypes__default.func
    /** Indicates the ProxyInput layer what value should be taken as default */

  });

  defineProperty(FileInput, "emptyValue", '');

  var CheckboxInput =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(CheckboxInput, _React$PureComponent);

    function CheckboxInput() {
      classCallCheck(this, CheckboxInput);

      return possibleConstructorReturn(this, getPrototypeOf(CheckboxInput).apply(this, arguments));
    }

    createClass(CheckboxInput, [{
      key: "onChange",
      value: function onChange(value) {
        this.props.setValue(value);
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        var _this$props = this.props,
            _this$props$ioProps = _this$props.ioProps,
            type = _this$props$ioProps.type,
            valid = _this$props$ioProps.valid,
            invalid = _this$props$ioProps.invalid,
            message = _this$props$ioProps.message,
            name = _this$props$ioProps.name,
            setValue = _this$props.setValue,
            value = _this$props.value,
            _this$props$className = _this$props.className,
            className = _this$props$className === void 0 ? '' : _this$props$className,
            innerRef = _this$props.innerRef,
            rest = objectWithoutProperties(_this$props, ["ioProps", "setValue", "value", "className", "innerRef"]);

        return React__default.createElement("input", _extends_1({
          ref: innerRef,
          "data-message": message,
          className: "".concat(classNameCreate(type, valid, invalid), " ").concat(className).trim(),
          name: name,
          type: type,
          onChange: function onChange(e) {
            return _this.onChange(e.target.checked);
          },
          checked: value
        }, rest));
      }
    }]);

    return CheckboxInput;
  }(React__default.PureComponent);

  defineProperty(CheckboxInput, "propTypes", {
    value: PropTypes__default.any,

    /** INJECTED FROM ProxyInput */
    ioProps: PropTypes__default.object.isRequired,

    /** INJECTED FROM ProxyInput */
    setValue: PropTypes__default.func
    /** Indicates the ProxyInput layer what value should be taken as empty */

  });

  defineProperty(CheckboxInput, "emptyValue", false);

  var RadioInput =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(RadioInput, _React$PureComponent);

    function RadioInput(props) {
      var _this;

      classCallCheck(this, RadioInput);

      _this = possibleConstructorReturn(this, getPrototypeOf(RadioInput).call(this, props));

      defineProperty(assertThisInitialized(_this), "state", {
        checked: null
      });

      defineProperty(assertThisInitialized(_this), "onChange", function (value) {
        var setValue = _this.props.setValue;

        _this.setState({
          checked: value
        });

        setValue(value);
      });

      _this.state = {
        checked: props.value
      };
      return _this;
    }

    createClass(RadioInput, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props = this.props,
            value = _this$props.value,
            setValue = _this$props.setValue;
        var checked = this.state.checked;
        setValue(checked ? value : null);
        this.extractOptions();
      }
    }, {
      key: "extractOptions",
      value: function extractOptions() {
        var children = this.props.children;
        var options = this.props.ioProps.options;

        if (!options) {
          var synOptions = [];
          React__default.Children.forEach(children, function (element) {
            if (!React__default.isValidElement(element)) return;
            var _element$props = element.props,
                value = _element$props.value,
                label = _element$props.children;
            value && synOptions.push({
              value: value,
              label: label
            });
          });
          this.setState({
            options: synOptions
          });
        } else {
          this.setState({
            options: options
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            _this$props2$ioProps = _this$props2.ioProps,
            type = _this$props2$ioProps.type,
            valid = _this$props2$ioProps.valid,
            invalid = _this$props2$ioProps.invalid,
            message = _this$props2$ioProps.message,
            name = _this$props2$ioProps.name,
            setValue = _this$props2.setValue,
            value = _this$props2.value,
            children = _this$props2.children,
            _this$props2$classNam = _this$props2.className,
            className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
            innerRef = _this$props2.innerRef,
            rest = objectWithoutProperties(_this$props2, ["ioProps", "setValue", "value", "children", "className", "innerRef"]);

        var _this$state = this.state,
            options = _this$state.options,
            checked = _this$state.checked;
        return React__default.createElement(React.Fragment, null, options && options.map(function (option) {
          return React__default.createElement("div", {
            "data-message": message,
            className: "".concat(classNameCreate(type, valid, invalid), " ").concat(className).trim()
          }, React__default.createElement("input", _extends_1({
            ref: innerRef,
            id: "radio_".concat(name, "_").concat(option.value.toString()),
            type: "radio",
            value: option.value,
            onChange: function onChange(e) {
              return _this2.onChange(option.value);
            },
            checked: option.value === checked
          }, rest)), React__default.createElement("label", {
            className: "iof-radio-label",
            htmlFor: "radio_".concat(name, "_").concat(option.value.toString())
          }, option.label));
        }));
      }
    }]);

    return RadioInput;
  }(React__default.PureComponent);

  defineProperty(RadioInput, "propTypes", {
    value: PropTypes__default.any,

    /** INJECTED FROM ProxyInput */
    ioProps: PropTypes__default.object.isRequired,

    /** INJECTED FROM ProxyInput */
    setValue: PropTypes__default.func
    /** Indicates the ProxyInput layer what value should be taken as default */

  });

  defineProperty(RadioInput, "emptyValue", '');

  var SelectInput =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(SelectInput, _React$PureComponent);

    function SelectInput() {
      var _getPrototypeOf2;

      var _this;

      classCallCheck(this, SelectInput);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(SelectInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

      defineProperty(assertThisInitialized(_this), "state", {
        options: []
      });

      return _this;
    }

    createClass(SelectInput, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.extractOptions();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var prevChildren = prevProps.children;
        var children = this.props.children;
        var prevOptions = prevProps.ioProps.options;
        var options = this.props.ioProps.options;

        if (!_$1.isEqual(options, prevOptions) || prevChildren !== children) {
          this.extractOptions();
        }
      }
    }, {
      key: "extractOptions",
      value: function extractOptions() {
        var _this$props = this.props,
            children = _this$props.children,
            setValue = _this$props.setValue,
            value = _this$props.value;
        var _this$props$ioProps = this.props.ioProps,
            options = _this$props$ioProps.options,
            defaultValue = _this$props$ioProps.defaultValue;

        if (!options) {
          var synOptions = [];
          React__default.Children.forEach(children, function (element) {
            if (!React__default.isValidElement(element)) return;
            var _element$props = element.props,
                extractedValue = _element$props.value,
                label = _element$props.children;
            synOptions.push({
              value: extractedValue,
              label: label
            });
          });
          var v = value || defaultValue || (synOptions[0] ? synOptions[0].value : null);
          setValue(v);
          this.setState({
            options: synOptions
          });
        } else {
          var _v = value || defaultValue || (options[0] ? options[0].value : null);

          setValue(_v);
          this.setState({
            options: options
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            _this$props2$ioProps = _this$props2.ioProps,
            type = _this$props2$ioProps.type,
            valid = _this$props2$ioProps.valid,
            invalid = _this$props2$ioProps.invalid,
            message = _this$props2$ioProps.message,
            name = _this$props2$ioProps.name,
            setValue = _this$props2.setValue,
            value = _this$props2.value,
            children = _this$props2.children,
            _this$props2$classNam = _this$props2.className,
            className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
            innerRef = _this$props2.innerRef,
            rest = objectWithoutProperties(_this$props2, ["ioProps", "setValue", "value", "children", "className", "innerRef"]);

        var options = this.state.options;
        return React__default.createElement("select", _extends_1({
          "data-message": message,
          className: "".concat(classNameCreate(type, valid, invalid), " ").concat(className).trim(),
          name: name,
          type: type,
          onChange: function onChange(e) {
            console.log(e.target.value);
            setValue(e.target.value);
          },
          ref: innerRef,
          value: value || ''
        }, rest), options && options.map(function (option, index) {
          return React__default.createElement("option", {
            key: option.value || index,
            value: option.value || ''
          }, option.label);
        }));
      }
    }]);

    return SelectInput;
  }(React__default.PureComponent);

  defineProperty(SelectInput, "emptyValue", '');

  var TextAreaInput =
  /*#__PURE__*/
  function (_React$PureComponent) {
    inherits(TextAreaInput, _React$PureComponent);

    function TextAreaInput() {
      classCallCheck(this, TextAreaInput);

      return possibleConstructorReturn(this, getPrototypeOf(TextAreaInput).apply(this, arguments));
    }

    createClass(TextAreaInput, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$ioProps = _this$props.ioProps,
            type = _this$props$ioProps.type,
            valid = _this$props$ioProps.valid,
            invalid = _this$props$ioProps.invalid,
            message = _this$props$ioProps.message,
            name = _this$props$ioProps.name,
            setValue = _this$props.setValue,
            value = _this$props.value,
            _this$props$className = _this$props.className,
            className = _this$props$className === void 0 ? '' : _this$props$className,
            innerRef = _this$props.innerRef,
            rest = objectWithoutProperties(_this$props, ["ioProps", "setValue", "value", "className", "innerRef"]);

        return React__default.createElement("textarea", _extends_1({
          "data-message": message,
          className: "".concat(classNameCreate(type, valid, invalid), " ").concat(className).trim(),
          name: name,
          onChange: function onChange(e) {
            return setValue(e.target.value);
          },
          value: value,
          ref: innerRef
        }, rest));
      }
    }]);

    return TextAreaInput;
  }(React__default.PureComponent);

  defineProperty(TextAreaInput, "propTypes", {
    value: PropTypes__default.any,

    /** INJECTED FROM ProxyInput */
    ioProps: PropTypes__default.object.isRequired,

    /** INJECTED FROM ProxyInput */
    setValue: PropTypes__default.func
    /** Indicates the ProxyInput layer what value should be taken as default */

  });

  defineProperty(TextAreaInput, "emptyValue", '');

  /** Entries of Inputs available for the default input registry */

  var entry = [{
    type: ['default', 'text', 'number', 'email', 'password', 'button', 'date', 'datetime-local', 'month', 'time', 'url', 'week', 'hidden', 'range'],
    component: TextInput
  }, {
    type: ['file'],
    component: FileInput
  }, {
    type: ['checkbox'],
    component: CheckboxInput
  }, {
    type: ['radio'],
    component: RadioInput
  }, {
    type: ['select'],
    component: SelectInput
  }, {
    type: ['textarea'],
    component: TextAreaInput
  }];

  /** This React Component Wraps the logic of the regular input fields to add validations and other controls through simple declarative components */

  var IOInput = function IOInput(_ref) {
    var props = _extends_1({}, _ref);

    return React.createElement(IOInputCollectorContext.Consumer, null, function (form) {
      return React.createElement(IOInputValidatorContext.Consumer, null, function (validation) {
        return React.createElement(IOInputMessageContext.Consumer, null, function (messages) {
          return React.createElement(IOInputRegistryContext.Consumer, null, function (registry) {
            return React.createElement(IOInputLinkageContext.Consumer, null, function (linkage) {
              return React.createElement(IOInputLayoutContext.Consumer, null, function (layouter) {
                return React.createElement(ProxyInput, {
                  contextProps: {
                    form: form,
                    validation: validation,
                    messages: messages,
                    registry: registry,
                    linkage: linkage,
                    layouter: layouter
                  },
                  ioProps: include(props, IOInput.propTypes),
                  standardProps: exclude(props, IOInput.propTypes),
                  ignoreMessagePool: props.ignoreMessagePool // Ignore message pool state, so collect method perfomance can increase drastically

                });
              });
            });
          });
        });
      });
    });
  };
  IOInput.propTypes = {
    /** 
     * Sets the default value of the IOInput. This value will be set when the reset process triggers.
     * If this value is a Function this function will be executed and the return value will be set as default value.
     * */
    defaultValue: PropTypes__default.oneOfType([PropTypes__default.any, PropTypes__default.func]),

    /** Sets the value into the input */
    value: PropTypes__default.any,

    /** Type of Input to be rendered */
    type: PropTypes__default.string,

    /** Name of the input. This information is required and it is used as a reference for all the async processes like message propagation and data collection through IOInputForm */
    name: PropTypes__default.string.isRequired,

    /** Indicates this input must not be serialized during the value recollection performed by the IOForm Context */
    exclude: PropTypes__default.bool,

    /**
     * Indicates this input must be included into the serialization even if the input has the "empty value" set at that moment
     * NOTE: This prop cannot coexist with "required" or "exclude" (it would be ignored).
     * */
    include: PropTypes__default.bool,

    /** 
    * This value can be either an array or a string (same as a single element array). The string(s) represent a key from the validation object given by the ValidatorContext or a regular expression to test the value against.
    * Optionally the regular expresion can be given as it is (RegExp object).
    * If an array is given, the validations will be runned one after another in the given orther. For the input to be valid all validations must pass.
    * If a function is give, the validation will consist on running the value agains the function. The given function must return either true or false to indicate the validation passed
    * If a boolean is given, the validation will automatically resolve on the boolean's value. This is useful if you want to have full control over the invalid/valid state
    */
    validate: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.object, PropTypes__default.array, PropTypes__default.string, PropTypes__default.func]),

    /** A flag that indicates the value must not be null or empty to be a valid input */
    required: PropTypes__default.bool,

    /** This flag forces the state/className for a valid input (Normally this happens internally when the value meets the validation criteria) */
    valid: PropTypes__default.bool,

    /** This flag forces the state/className for an invalid input (Normally this happens internally when the value does NOT meet the validation criteria) */
    invalid: PropTypes__default.bool,

    /** This string forces a message into the message propagation channel. If present it will override any internally generated message */
    message: PropTypes__default.string,

    /** This function is called when an input changes its value and the value passes all the necessary validations */
    onValue: PropTypes__default.func,

    /** This function is called when an input changes its value for any value */
    onChange: PropTypes__default.func,

    /** This function is called when the input processes generate a new message. The function receives as arguments the "message" itself and the "field" which is the name given at the "name" prop */
    onMessage: PropTypes__default.func,

    /** This function is called when the input fails a validation. The function is called with the message and the field name as arguments */
    onInvalid: PropTypes__default.func,

    /** Message to send when the input value resolves in "invalid" */
    invalidMessage: PropTypes__default.string,

    /** Message to send when the input value resolves in "valid" */
    validMessage: PropTypes__default.string,

    /** Function to use as filter for any upcoming value from the I/O flow to be set */
    filterIn: PropTypes__default.func,

    /** Function to use as filter for any outgoing value from the I/O flow to be serialized */
    filterOut: PropTypes__default.func,

    /** Fields to link. Any value change will be propagated to the fields within the same IOForm that match the link name and the field name */
    link: PropTypes__default.oneOfType([PropTypes__default.array, PropTypes__default.string]),

    /** Options available by option selectable intpu fields. For example: Radio and Select */
    options: PropTypes__default.array
  };
  IOInput.defaultProps = {
    type: 'text',
    required: false,
    exclude: false,
    ignoreMessagePool: false
    /**
     * Adds a new entry into the InputFactory registry of components to be used as inputs and returns a HOC with the wrapper IOInput
     * @param {string|array} type Type name(s) of the input to register
     * @param {registry} [registry] Name of the registry to use
     * @return {Function<Component>} 
     * */

  };
  var withIO = function withIO(type) {
    var registry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
    return function (Component) {
      InputFactory.add(registry, type, Component);
      return (
        /*#__PURE__*/
        function (_React$PureComponent) {
          inherits(_class, _React$PureComponent);

          function _class() {
            classCallCheck(this, _class);

            return possibleConstructorReturn(this, getPrototypeOf(_class).apply(this, arguments));
          }

          createClass(_class, [{
            key: "render",
            value: function render() {
              return React.createElement(IOInput, _extends_1({
                type: type
              }, this.props));
            }
          }]);

          return _class;
        }(React.PureComponent)
      );
    };
  };
  /** DEFAULT REGISTRY */

  InputFactory.register('default', entry);
  /** DEFAULT EXPORT */

  IOForm.Input = IOInput;
  IOForm.Message = IOInputMessage;

  exports.EmptyValueError = EmptyValueError;
  exports.IOInput = IOInput;
  exports.IOInputLayoutContext = IOInputLayoutContext;
  exports.IOInputMessage = IOInputMessage;
  exports.IOInputMessageContext = IOInputMessageContext;
  exports.IOInputRegistryContext = IOInputRegistryContext;
  exports.IOInputValidatorContext = IOInputValidatorContext;
  exports.InputError = InputError;
  exports.LayoutContext = LayoutContext;
  exports.MessageContext = MessageContext;
  exports.RegistryContext = RegistryContext;
  exports.ValidatorContext = ValidatorContext;
  exports.default = IOForm;
  exports.defaultLayouter = defaultLayouter;
  exports.exclude = exclude;
  exports.getMessagesFromIntl = getMessagesFromIntl;
  exports.include = include;
  exports.withIO = withIO;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
